export const messaggioSelector = (state) => state.messaggio.messaggio;

export const snackbarSelector = (state) => state.messaggio.snackbar;